export const DEFAULT_STATUS_TIMEOUT = 8000;


// WEBPACK FOOTER //
// ./src/constants/SystemConsts.tsx